/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-25 21:40:02
 * @LastEditors: liyong
 * @LastEditTime: 2022-08-03 15:56:12
 */

import { tzRoleType, zsRoleType, drRoleType } from '@/utils/dataMap';
import permissionGetters from './modules/permission/getters';
import userGetters from './modules/user/getters';
import teamGetters from './modules/team/getters';
export default {
	...permissionGetters,
	...userGetters,
	...teamGetters,

	// 抖音行业大类
	dyCategoryList(state) {
		return state.vuex_dy_category.map(({ name, category_id }) => ({ label: name, value: category_id }));
	},
	// 快手行业大类
	ksCategoryList(state) {
		return state.vuex_ks_category.map(({ name, category_id }) => ({ label: name, value: category_id }));
	},
	// 视频号行业大类
	spCategoryList(state) {
		return state.vuex_sp_category.map(({ name, category_id }) => ({ label: name, value: category_id }));
	},

	showSideMenu(state) {
		return state.vuex_subMenuList.some(item => item.meta.title);
	},
};
